// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import USER_CONSTANTS from '../User.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  personalData: null,
  isRemembered: null,
  airmiles: null,
  rewards: null,
  survey: null,
  children: null,
  favoriteStore: null,
  defaultStore: null,
  isRegisteredUserCallDone: false,
  isFetching: false,
  isLoginInProcess: null,
  brandToggleInProgress: false,
});
/* eslint-disable */

const getUserReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_CONSTANTS.SET_IS_EXPRESS_ELIGIBLE:
      return state.setIn(['personalData', 'isExpressEligible'], payload);
    case USER_CONSTANTS.SET_IS_REGISTERED_USER_CALL_DONE:
      return state.set('isRegisteredUserCallDone', payload);
    case USER_CONSTANTS.SET_IS_FETCHING:
      return state.set('isFetching', payload);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

const UserReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_CONSTANTS.SET_USER_INFO:
      return state
        .set('isFetching', false)
        .set(
          'personalData',
          fromJS({
            contactInfo: {
              firstName: payload.firstName,
              lastName: payload.lastName,
              emailAddress: payload.email,
              phoneNumber: payload.phone,
              profileAddress: payload.profileAddress,
            },
            loyalty: {
              currentTier: payload.currentTier,
              currentTierEffectiveDate: payload.currentTierEffectiveDate,
              currentTierExpirationDate: payload.currentTierExpirationDate,
              targetSpendForNextTier: payload.targetSpendForNextTier,
              redeemablePoints: payload.redeemablePoints,
            },
            userId: payload.userId && payload.userId.toString(),
            isGuest: !payload.isLoggedin,
            isRemembered: payload.isRemembered,
            contextAttributes: payload.contextAttributes,
            isPlcc: payload.isPlcc,
            isPlccIC: payload.isPlccIC,
            userBirthday: payload.userBirthday,
            profileCompletion: payload.userProfileState.profileCompletion,
            isExpressEligible: payload.isExpressEligible,
            associateId: payload.associateId,
            favStoreId: payload.favStoreId,
            plccCardId: payload.plccCardId,
            plccCardNumber: payload.plccCardNumber,
            sflListId: payload.sflListId,
            defaultAddress: payload?.defaultAddress,
            plccPromoEligible: payload?.plccPromoEligible,
            phoneCountryCode: payload?.phoneCountryCode,
          })
        )
        .set(
          'airmiles',
          fromJS({
            accountNumber: payload.airmilesAccountNumber,
          })
        )
        .set(
          'rewards',
          fromJS({
            accountNumber: payload.myPlaceNumber,
            rewardPoints: payload.currentPoints,
            rewardDollars: payload.currentMonthsRewards,
            rewardPointsToNextReward: payload.pointsToNextReward,
          })
        )
        .set(
          'perk',
          fromJS({
            totalSpend: payload.totalSpend,
            currentPerkLevel: payload.currentPerkLevel,
            nextPerkLevel: payload.nextPerkLevel,
            spendLeftForNextPerk: payload.spendLeftForNextPerk,
          })
        )
        .set(
          'survey',
          fromJS({
            questions: null,
            answers: payload.surveyAnswers,
          })
        )
        .set(
          DEFAULT_REDUCER_KEY,
          setCacheTTL(
            typeof payload.userCachingTTL !== 'undefined'
              ? payload.userCachingTTL
              : USER_CONSTANTS.GET_USER_INFO_TTL
          )
        );
    case USER_CONSTANTS.SET_CHILDREN:
      return state.set('children', fromJS(payload.children));
    case USER_CONSTANTS.SET_GEO_COORDINATES:
      return state.set('geoLatLong', payload.geoLatLong);
    case USER_CONSTANTS.SET_FAVORITE_STORE:
      return state.set(
        'favoriteStore',
        fromJS({
          name: payload.favoriteStore.name,
          address: payload.favoriteStore.address1,
          phone: payload.favoriteStore.phone,
          state: payload.favoriteStore.state,
          zipCode: payload.favoriteStore.zipCode,
          city: payload.favoriteStore.city,
        })
      );
    case USER_CONSTANTS.RESET_USER_INFO:
      return initialState;
    case USER_CONSTANTS.CLEAR_USER_INFO_TTL:
      return state.set(DEFAULT_REDUCER_KEY, null);
    case USER_CONSTANTS.SET_DEFAULT_STORE:
      return state.set('defaultStore', payload);
    case USER_CONSTANTS.RESPONSE_PLCC_CARD_ID_INFORMATION:
      return state.setIn(['personalData', 'plccCardId'], payload);
    case USER_CONSTANTS.RESPONSE_SET_PLCC_INFORMATION:
      return state.setIn(['personalData', 'plccCardNumber'], payload);
    case USER_CONSTANTS.SET_SURVEY_QUESTIONS:
      return state.set(
        'survey',
        fromJS({
          questions: payload,
          answers: [],
        })
      );
    case USER_CONSTANTS.SET_USER_NEAR_DATA:
      return state.set('userNearStoreData', payload);
    case USER_CONSTANTS.SET_LOGIN_IN_PROCESS_STATE:
      return state.set('isLoginInProcess', payload);
    case USER_CONSTANTS.SET_BRAND_TOGGLE_IN_PROGRESS:
      return state.set('brandToggleInProgress', payload);
    default:
      return getUserReducer(state, { type, payload });
  }
};

export default UserReducer;
